"use strict";

var incidentProgressLayer = function () {
  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    loadToggledListenerForMap(map, mapLayers, mapId);
    loadDataUpdatedListenerForMap(map, mapLayers, mapId);
    loadFiltersUpdatedListenerForMap(map, mapLayers, mapId);
  };

  var loadToggledListenerForMap = function (map, mapLayers, mapId) {
    MapFunctions.whenLayerToggled(
      mapId,
      "incidentProgress",
      function (isEnabled, sameSpatialFilter, sameView, sameGroup) {
        if (isEnabled) {
          if (mapLayers.incidentProgressLayer && sameSpatialFilter && sameView && sameGroup) {
            RamMapFunctions.resizeLayerMarkers(
              mapLayers.incidentProgressLayer,
              IncidentsIcon.getIncidentsMarkerIcon,
            );
            map.addLayer(mapLayers.incidentProgressLayer);
            Clustering.setState("incidentProgress");
          } else {
            const isFetching = Tree.get([
              "layers",
              Tree.get("mapId"),
              "incidentProgress",
              "isFetching",
            ]);
            if (sameSpatialFilter && sameView && isFetching) {
              // Temp solution to prevent laoding twice from dataView and filters update
              return;
            }
            loadLayer();
          }
        } else {
          if (MapFunctions.mapHasLayer(map, mapLayers.incidentProgressLayer)) {
            map.removeLayer(mapLayers.incidentProgressLayer);
          }
        }
      },
    );
  };

  var loadLayer = function () {
    var mapId = Tree.get("mapId");
    var filters = Tree.get("filters");
    if (!filters.catchments.length && filters.searchString) {
      Tree.set(["layers", mapId, "incidentProgress", "data"], []);
    } else {
      Tree.set(["layers", mapId, "incidentProgress", "isFetching"], true);
      ReportApiCalls.getIncidentProgress(filters, function (data) {
        Tree.set(["layers", mapId, "incidentProgress", "isFetching"], false);
        Tree.set(["layers", mapId, "incidentProgress", "data"], data);
        Tree.set(
          ["layers", mapId, "incidentProgress", "spatialView"],
          Tree.get("spatialView", mapId),
        );
      });
    }
  };

  var loadDataUpdatedListenerForMap = function (map, mapLayers, mapId) {
    MapFunctions.whenLayerDataUpdated(Tree, mapId, "incidentProgress", function (data) {
      if (Filters.spatialFilterIsSet()) {
        data = spatiallyFilterIncidentData(data);
      }
      const geoJsonData = CleanData.cleanGeoJSON(data);
      mapLayers.incidentProgressLayer = createLayerAndAddToMap(map, mapLayers, geoJsonData);
      Clustering.setState("incidentProgress");
      if (
        Tree.get("layers", mapId, "catchments", "isEnabled") &&
        !Tree.get("layers", mapId, "catchments", "isFetching")
      ) {
        Table.render();
      }
    });
  };

  var createLayerAndAddToMap = function (map, mapLayers, data) {
    if (mapLayers.incidentProgressLayer) {
      map.removeLayer(mapLayers.incidentProgressLayer);
    }
    mapLayers.incidentProgressLayer = createLayer(data);
    IncidentPopup.loadDomListeners();
    mapLayers.incidentProgressLayer.addTo(map);
    return mapLayers.incidentProgressLayer;
  };

  var createLayer = function (data) {
    var layer = L.featureGroup();

    L.geoJson(data, {
      pointToLayer: function (feature, latlng) {
        const incidentsData = feature.properties;
        const marker = L.marker(latlng, {
          icon: IncidentsIcon.getIncidentsMarkerIcon(incidentsData),
        });
        return marker;
      },
      onEachFeature: function (feature, layer) {
        layer.bindPopup(
          () => IncidentPopup.getIncidentsPopupHtml(feature.properties),
          IncidentPopup.getPopupOptions(),
        );
      },
    }).addTo(layer);
    IncidentPopup.loadPopupEventListeners(layer);

    return layer;
  };

  var loadFiltersUpdatedListenerForMap = function (map, mapLayers, mapId) {
    // Only watch for specific filters since other filters updates are already handled in treeUpdates
    // @TODO: Investigate why listening to filters update causes an infinite loop while searching
    Tree.watch({
      dataSort: ["filters", "dataSort"],
    }).on("update", function (e) {
      if (
        Tree.get("dataView") === "iddeView" &&
        MapFunctions.mapHasLayer(map, mapLayers.incidentProgressLayer) &&
        Tree.get("layers", mapId, "incidentProgress", "isEnabled")
      ) {
        loadLayer();
      }
    });
  };

  var spatiallyFilterIncidentData = function (incidentData) {
    const filters = Tree.get("filters");
    return incidentData.filter((datum) => {
      return (
        filters.receivingWaters.includes(datum.catchment["drains_to_rw"]) ||
        filters.receivingWaters.includes(datum.catchment["drains_to_c"]) ||
        filters.catchments.includes(datum.catchment["catchid"])
      );
    });
  };

  return {
    loadLayerListenersForMap,
    loadLayer,
    createLayer,
  };
};

module.exports = incidentProgressLayer();

const MapFunctions = require("../mapFunctions/mapFunctions");
const Tree = require("../../tree");
const ReportApiCalls = require("../reportApiCalls");
const CleanData = require("../mapFunctions/cleanData");
const Table = require("../mapFunctions/table");
const Filters = require("../mapFunctions/filters");
const Clustering = require("../mapFunctions/clustering");
const IncidentsIcon = require("./incidentsIcon");
const IncidentPopup = require("./incidentPopup");
const RamMapFunctions = require("../../mapFunctions/mapFunctions");
